import React, { useEffect, useState } from 'react';

import UserBigItem from './user-big-item/UserBigItem';
import { useGetMyDetails } from '../../../services/redux/api/usersApi';
import UserSmallItem from './user-small-item/UserSmallItem';
import theme from '../../../styles/theme';
import clsx from 'clsx';
import { useStyles } from './UsersList.styles';
import { Paths } from '../../../shared/paths';
import { useNavigate } from 'react-router-dom';
import { IUser } from '../../../types/interfaces/user';
import Search from '../search/Search';

interface UsersListProps {
  users: IUser[];
  type?: 'big' | 'small';
  communityId?: string; // needs if pageType === 'community'
  showStatusButton?: boolean;
  showSearch?: boolean;
}

export default function UsersList(props: UsersListProps) {
  const {
    users,
    type = 'big',
    showStatusButton = false,
    communityId,
    showSearch = false,
  } = props;
  const { classes } = useStyles(theme);
  const navigate = useNavigate();
  const [filterValue, setFilterValue] = useState('');
  const [filteredUsers, setFilteredUsers] = useState<IUser[]>(users);

  useEffect(() => {
    if (!filterValue) {
      setFilteredUsers(users);
    } else {
      setFilteredUsers(
        users.filter(
          (u) =>
            u.firstname?.toLowerCase().indexOf(filterValue.toLowerCase()) !==
              -1 ||
            u.lastname?.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1,
        ),
      );
    }
  }, [filterValue, users]);

  function userClickHandler(u) {
    navigate(`${Paths.users.root}/${u.id}`);
  }

  return (
    <div
      className={clsx(
        classes.usersListWrapper,
        type === 'small' && classes.narrowScreen,
      )}>
      {showSearch && (
        <Search
          fullWidth
          value={filterValue}
          onChange={setFilterValue}
          className={classes.usersListSearch}
        />
      )}
      {filteredUsers?.map((u) => (
        <React.Fragment key={u.id}>
          {type === 'big' ? (
            <UserBigItem
              user={u}
              communityId={communityId}
              showStatusButton={showStatusButton}
            />
          ) : (
            <UserSmallItem
              user={u}
              onUserClick={userClickHandler}
              borderOnHover={true}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
